
<div class="page_container" *ngIf="currentForm==='basicForm'">
  <div class="static_steps" [formGroup]="form">
    <div class="left_part side_part">
      <div class="step">
        <div class="step_title">
          <span>
            {{"Catalogs.catalog_informations"|translate}}
          </span>
          <button class="add_btn" *appHasPermission="submitPermission()" (click)="editBasicInfo()">
            <img src="../../../../../assets/icones/edit_catalog.svg" alt="">
            <span>{{"common.edit"|translate}}</span>
          </button>
        </div>
        <div class="content info_img">
          <div class="content_img" (change)="getCatalogImg($event)">
            <img class="icon_user"
              [src]="imageCatalog ? 'data:;base64,' + imageCatalog : defaultVariantAvatar"
              alt="" (error)="onImageError($event)">
          </div>
          <div class="fields_info">
            <div class="field field_info">
              <label for=""> {{"common.name"|translate}} </label>
              <span class="summary_field">{{this.form.get('name')?.value}}</span>
            </div>
            <div class="field field_info">
              <label for="">{{"common.status"|translate}}</label>
              <span *ngIf="this.form.get('status')?.value" class="summary_field"> {{ ('Catalogs.publish_status.' + this.form.get('status')?.value.toLowerCase()) | translate }}</span>
            </div>
            <div class="inline_block no_padding">
              <div class="field field_info">
                <label for="">
                  {{"common.start_date"|translate}}
                </label>
                <span class="summary_field">{{this.form.get('start_date')?.value}}</span>
              </div>
              <div class="field field_info">
                <label for="">
                  {{"common.end_date"|translate }}
                </label>
                <span class="summary_field">{{this.form.get('end_date')?.value}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="step first_step">
        <div class="step_title">
          <span>
            {{"Catalogs.companies_locations"|translate}} ({{selectedLocations.length}})
          </span>
          <button class="add_btn" *appHasPermission="submitPermission()" (click)="goTo('insertLocations')">
            <img src="assets/icones/add_icon.svg" alt="">
            <span>{{"common.insert"|translate}}</span>
          </button>
        </div>
        <div class="content">
          <div *ngIf="!selectedLocations || selectedLocations.length === 0">
            {{"Catalogs.no_locations_available"|translate }}
          </div>
          <table class="listing_table" *ngIf="selectedLocations.length > 0">
            <thead class="header_stiky">
              <tr class="head_table">
                <th>{{"Catalogs.company_location"|translate}}</th>
                <th>{{"common.custom_discount"|translate}}</th>
                <th>{{"Catalogs.total_discount"|translate}}</th>
                <th>{{"Catalogs.currency"|translate}}</th>
                <th>{{"common.del"| translate}}</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let location of selectedLocations let i = index">
                <tr class="body_table">
                  <td class="td_block">
                    <span class="bold_span">{{ location.company_name + ' - ' + location.name }}</span><br>
                    <span class="light_span">{{location.apartment}}</span>
                  </td>
                  <td class="td_block">
                    <span class="bold_span">{{ location.custom_discount ? "-"+location.custom_discount+"%" : 'N/A' }}</span>
                  </td>
                  <td>
                    {{sumDiscount(location.custom_discount) ? "-" +sumDiscount(location.custom_discount)+"%" : 'N/A' }}
                  </td>
                  <td>
                    <span class="descr_elemnt">
                      {{location.currency?.name}}
                      </span>
                  </td>
                  <td>
                    <button *appHasPermission="{ module: 'catalog', action: 'edit' }" (click)="removeLocationConfirmationDialog(location)">
                      <img src="assets/icones/red-delete-icon.svg" alt="">
                    </button>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="right_part side_part">
    <div [formGroup]="generalRulesform" class="step">
      <div class="step_title">
        <span>
          {{"Catalogs.general_rules"| translate}}
        </span>
        <button class="add_btn" *appHasPermission="submitPermission()" (click)="editGeneralRules()">
          <img src="../../../../../assets/icones/edit_catalog.svg" alt="">
          <span>{{"common.edit"|translate}}</span>
        </button>
      </div>
      <div class="content customers_chip">
        <mat-tab-group>
          <mat-tab>
            <ng-template mat-tab-label>
              <div class="title_block">
                <img src="assets/icones/overall-price.svg" alt="">
                {{"Catalogs.overall_discount_adj"|translate}}
              </div>
            </ng-template>
            <div class="inline_block">
              <div class="field category_field">
                <input type="number" formControlName="general_discount" readonly (input)="onGeneralDiscountChange($event)">
                <span class="indicate_input custom_indic">%</span>
              </div>
            </div>
          </mat-tab>
          <mat-tab>
            <ng-template mat-tab-label>
              <div class="title_block">
                <img src="assets/icones/overall-quantity.svg" alt="">
                {{"Catalogs.overall_quantity_adj"|translate}}
              </div>
            </ng-template>
            <div class="inline_block mat_tab_block">
              <div class="field">
                <input type="number" formControlName="increment" readonly (input)="onGeneralIncrementChange($event)">
                <span class="indicate_input custom_indic">{{"Catalogs.increment"|translate}}</span>
              </div>
              <div class="field">
                <input type="number" formControlName="min_qte" readonly (change)="onGeneralMinChange($event)">
                <span class="indicate_input custom_indic">{{"Catalogs.min"|translate}}</span>
              </div>
              <div class="field">
                <input type="number" formControlName="max_qte" readonly (change)="onGeneralMaxChange($event)">
                <span class="indicate_input custom_indic">{{"Catalogs.max"|translate}}</span>
              </div>
            </div>
            <div class="inline_block">
              <div class="field">
                <label for="">{{ "Catalogs.can_be_sold_out_of_stock" | translate }}</label>
                <mat-slide-toggle formControlName="can_be_sold_out_of_stock" [disabled]="true">
                </mat-slide-toggle>
              </div>
              <div class="field">
                <label for="">{{ "Catalogs.show_stock" | translate }}</label>
                <mat-slide-toggle formControlName="show_stock" [disabled]="true">
                </mat-slide-toggle>
              </div>
            </div>
          </mat-tab>
          <mat-tab disabled>
            <ng-template mat-tab-label>
              <div class="title_block">
                <img src="assets/icones/volume.svg" alt="">
                {{"Catalogs.overall_volume_adj"|translate}}
              </div>
            </ng-template>
          </mat-tab>
        </mat-tab-group>
      </div>
    </div>
      <div class="step">
        <div class="step_title">
          <span class="curser" (click)="goTo('customProducts')">
            {{"Catalogs.product"|translate}} ({{ catalog?.nbr_products || 0}})
          </span>
          <button class="add_btn" *appHasPermission="submitPermission()" (click)="goTo('insertProducts')">
            <img src="assets/icones/add_icon.svg" alt="">
            <span>{{"common.insert"|translate}}</span>
          </button>
        </div>
        <div class="total_title" (click)="goTo('customProducts')">
          <span class="total">
            {{ catalog?.nbr_products || 0}}
            <span [style]="{
              fontWeight: '500',
              fontSize: '14px',
              display: 'flex',
              alignItems: 'center',
              gap: '5px'
            }" *ngIf="getProductsWithoutPricing()">
              <img [title]="'There are (' + getProductsWithoutPricing() +') products without pricing!' " src="../../../../../assets/icones/alert-circle.svg" alt="">
              {{ getProductsWithoutPricing() > 1 ? getProductsWithoutPricing() + ' products' : getProductsWithoutPricing() + ' product' }} without pricing!
            </span>
          </span>
          <div class="action_btn btn_edit">
            <span class="included">{{"Catalogs.products_included"|translate}}</span>
            <img src="../../../../../assets/icones/blue_eye.svg" alt="">
          </div>
        </div>
        <div class="content customers_chip">
          <div class="field">
            <label for="" class="label_list">
              <img src="assets/icones/brands.svg" alt="">
              <span>{{"brands.brands"|translate}} ({{getUniqueBrands().length}})</span>
            </label>
            <div class="inline_block">
              <span class="item_tag" *ngFor="let brand of getUniqueBrands()">{{brand.name}}</span>
            </div>
          </div>
          <div class="field">
            <label for="" class="label_list">
              <img src="assets/icones/categories.svg" alt="">
              <span>{{"Categories.categories"|translate}} ({{getUniqueCategories().length}})</span>
            </label>
            <div class="inline_block">
              <span class="item_tag" *ngFor="let category of getUniqueCategories()">{{category.name}}</span>
            </div>
          </div>
          <div class="field">
            <label for="" class="label_list">
              <img src="assets/icones/tags.svg" alt="">
              <span>
               {{"Labels.labels"|translate}} ({{getUniqueTags().length}})
              </span>
            </label>
            <div class="inline_block">
                <span class="item_tag" *ngFor="let tag of getUniqueTags()">{{tag.name}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="submet_btns">
    <button class="save_btn_pop_up cancel_btn_pop_up" (click)="canceled()">
      <span>{{"common.cancel"|translate | uppercase }}</span>
    </button>
    <button class="save_btn_pop_up red_btn" *appHasPermission="{ module: 'catalog', action: 'delete' }" (click)="deleteCatalog()">
      <span>
        {{ catalogId ? ('common.remove' | translate) : ('Catalogs.CREATE_CATALOG' | translate) }}
      </span>
      <img alt="" src="../../../../../assets/icones/delete.svg">
    </button>
  </div>
</div>
<app-inserting-products
*ngIf="currentForm ==='insertProducts' && (selectedProducts.length > 0 || selectedProductsLoaded)"
[selectedProducts0]="selectedProducts"
(cancelProducts)="cancel($event)"
(saveProducts)="onSaveProducts($event)"
>
</app-inserting-products>
<app-inserting-locations
*ngIf="currentForm ==='insertLocations'"
[selectedLocationsO]="selectedLocations"
[currentCustomDiscount]="currentCustomDiscount"
(cancelLocations)="cancel($event)"
(saveLocations)="onSaveLocations($event)">
</app-inserting-locations>
<app-custom-catalog-products
*ngIf="currentForm ==='customProducts' && (selectedProducts.length > 0 || selectedProductsLoaded)"
[edit]="true"
[selectedProducts0]="selectedProducts"
[generalRules0]="generalRules"
(saveCustomProducts)="onSaveCustomProducts($event)"
(saveGeneraleRule)="saveGeneraleRule($event)"
(cancelCustom)="cancel($event)"
>
</app-custom-catalog-products>
